// extracted by mini-css-extract-plugin
module.exports = {"connect":"footer_connect__YZp68","contrastLink":"footer_contrastLink___K5LY","version":"footer_version__ahhyk"};